<script setup lang="ts">
import { UIIcon } from '@groover-dev/groover-ui'

import SpotifyPlaylistDisplayElement from '~/components/spotify/SpotifyPlaylistDisplayElement.vue'

import { useSegmentTrack } from '~/composables/Segment/useSegmentTrack'

type Props = {
  spotifyPlaylists: { spotify_id: string }[]
}

const { spotifyPlaylists } = defineProps<Props>()
const segmentTrack = useSegmentTrack()

const displayedPlayListUrls = computed(() => {
  return spotifyPlaylists.map(
    ({ spotify_id }: { spotify_id: string }) => spotify_id,
  )
})

function handleIframeClick(): void {
  segmentTrack('Curator Profile - Spotify Player Clicked')
}
</script>

<template>
  <ul
    class="tw-grid tw-grid-cols-1 tw-gap-sm md:tw-grid-cols-2 lg:tw-place-items-start"
  >
    <SpotifyPlaylistDisplayElement
      v-for="(spotifyPlaylistId, index) in displayedPlayListUrls"
      :key="index"
      html-tag="li"
      :spotify-playlist-id="spotifyPlaylistId"
      small
      class="tw-flex tw-w-full tw-flex-wrap tw-items-center tw-overflow-hidden"
      @iframe-click="handleIframeClick"
    >
      <template #default="{ playlistInfos }">
        <div
          v-if="playlistInfos && playlistInfos.followers"
          class="tw-mt-2 tw-flex tw-h-8 tw-w-full tw-items-center tw-justify-center tw-gap-1 tw-rounded-xl tw-bg-gradient-to-r tw-from-[#282828] tw-to-[#282828ee] tw-p-2 lg:tw-h-10 lg:tw-p-4"
        >
          <UIIcon
            name="fa6-solid:heart"
            class="tw-text-icon-inverse"
            size="sm"
            aria-hidden
          />
          <span class="tw-text-sm tw-font-medium tw-text-inverse">{{
            $t(
              'components.influencer.profile.SpotifyPlaylistDisplayCollection.cta.likes',
              { count: formatNumber(playlistInfos.followers) },
            )
          }}</span>
        </div>
      </template>
    </SpotifyPlaylistDisplayElement>
  </ul>
</template>
